import { fetchAuthSession } from '@aws-amplify/auth';
import { API_BASE } from './config';

let organizationId = null;
let actorId = null;
let revision = 0;
export function selectApiOrganization(id, actor = actorId) {
  organizationId = id || null;
  actorId = actor || null;
  revision += 1;
}
export const apiOrganization = () => organizationId;
export const apiScope = () => `${actorId || ''}:${organizationId || ''}`;
/** Attach identity only to this application's configured gateways. Capture scope before token refresh. */
export async function mindFetch(input, init = {}) {
  const url = new URL(input, window.location.origin);
  const allowed = [API_BASE].some((base) => {
    const target = new URL(base, window.location.origin);
    return (
      url.origin === target.origin &&
      (url.pathname === target.pathname ||
        url.pathname.startsWith(`${target.pathname.replace(/\/$/, '')}/`))
    );
  });
  if (!allowed) throw new Error('Unrecognized Mind API destination');
  const selected = organizationId,
    version = revision;
  const session = await fetchAuthSession();
  const token = session.tokens?.idToken?.toString();
  if (!token) throw new Error('Sign in to continue');
  if (version !== revision) throw new Error('Organization changed');
  const headers = new Headers(init.headers);
  headers.set('Authorization', `Bearer ${token}`);
  headers.delete('x-organization-id');
  if (selected) headers.set('x-organization-id', selected);
  const response = await fetch(url.toString(), { ...init, headers });
  if (version !== revision) throw new Error('Organization changed');
  return response;
}
